import { SurtitleTagType } from 'src/app/content-management/shared/enums/surtitle-tag-type';
import { ISelectListItem } from './i-select-list-item';

export interface ITypedSelectListItem {
  tag: ISelectListItem;
  tagType: SurtitleTagType;
}
export class TypedSelectListItem implements ITypedSelectListItem {
  constructor(public tag: ISelectListItem, public tagType: SurtitleTagType) {}
}
